const state = {
  isActive: false,
  content: {
    title: "",
    message: "",
    button: "",
    hasError: false,
    onClose: null
  }
};

const getters = {
  getIsActive: state => state.isActive,
  getContent: state => state.content
};

const mutations = {
  TOGGLE_ALERT: (state, payload) => {
    state.isActive = payload;

    if (!payload && state.content.onClose) {
      state.content.onClose.call();
      state.onClose = null;
    }
  },

  SET_CONTENT: (state, payload) => {
    state.content.title = payload.title;
    state.content.message = payload.message;
    state.content.button = payload.button;
    state.content.hasError = payload.hasError;
    state.content.onClose = payload.onClose || null;
  }
};

const actions = {
  toggleAlert: ({ commit }, payload) => commit("TOGGLE_ALERT", payload),
  setContent: ({ commit }, payload) => commit("SET_CONTENT", payload)
};

export default {
  state,
  getters,
  mutations,
  actions
};
